<template>
  <q-table
    title="User Group List"
    :columns="columnDefs"
    :rows="rowData"
    row-key="userGroupUid"
    :filter="filter"
    :filter-method="customFilter"
    :loading="loading"
    :pagination="pagination"
    :sort-method="CommonAdminHelper.customSort"
    virtual-scroll
    wrap-cells
    class="tableClass"
  >
    <template v-slot:top>
      <q-input
        outlined
        dense
        style="width: 10%"
        label="Filter User Groups"
        debounce="300"
        v-model="filter"
        :disable="noScopeFilter"
      />
      <q-toggle
        v-model="noScopeFilter"
        @update:model-value="toggleNoScopeFilter"
        label="No Scope User Groups"
        style="padding-left: 20px"
      />
      <q-space />
      <q-btn
        color="primary"
        unelevated
        :disable="loading"
        label="Add User Group"
        no-caps
        @click="addRow()"
        icon="add"
      />
    </template>
    <template v-slot:body-cell-actions="props">
      <q-td :props="props">
        <div style="display: flex; align-items: center; justify-content: center;">
          <q-btn
            dense
            round
            flat
            :color="!darkMode ? 'black' : 'white'"
            @click="editRow(props)"
            icon="edit"
            title="Edit"
            aria-label="Edit"
          />
          <q-btn
            dense
            round
            flat
            color="red"
            @click="deleteRow(props)"
            icon="delete"
            title="Delete"
            aria-label="Delete"
          />
        </div>
      </q-td>
    </template>
  </q-table>
</template>

<script>
import { ref, watch } from "vue";
import CommonAdminHelper from "../helper/CommonAdminHelper.js";
import CommonHelper from "../helper/CommonHelper.js";
import NotificationHelper from "../helper/NotificationHelper";
import EmailService from "../service/EmailService.js";

export default {
  name: "UserGroupsTable",
  props: {
    currentUserUID: String,
    darkMode: Boolean,
    adminForm: Object,
    adminDelete: Object
  },
  emits: ["setAdminMode"],
  setup(props, { emit }) {
    const columnDefs = ref([
      { label: "Name", name: "name", field: "name", align: "center", sortable: true },
      { label: "Access", name: "access", field: "access", align: "center", sortable: true, format: (val) => { return val.replaceAll("_", " ") } },
      { label: "Scopes", name: "scopes", field: "scopes", align: "center", sortable: true },
      { label: "Actions", name: "actions", field: "actions", align: "center" }
    ]);

    const rowData = ref([]);
    const filter = ref("");
    const loading = ref(false);
    const pagination = ref({ rowsPerPage: 10, sortBy: "name", ascending: true })
    const noScopeFilter = ref(false);

    watch(
      () => props.currentUserUID,
      () => {
        if (props.currentUserUID !== null && props.currentUserUID !== undefined) {
          getUserGroups();
        }
      },
      { deep: true, immediate: true }
    );

    async function getUserGroups() {
      try {
        loading.value = true;

        const response = await CommonHelper.getUserGroups(true);
        contructUserGroupData(response);
      } catch (error) {
        EmailService.sendErrorEmail("UserGroupsTable.vue - getUserGroups", error);
        NotificationHelper.createErrorNotification("Error encountered. Please try again.");
        loading.value = false;
      }
    }

    function contructUserGroupData(res) {
      const tempArray = res.map((userGroup) => {
        return {
          userGroupUid: userGroup.uid,
          name: userGroup.name,
          access: CommonAdminHelper.getAlphabetizedString(userGroup.accessLevel),
          scopes: CommonAdminHelper.getAlphabetizedString(userGroup.scopesAccess),
          emails: userGroup.emails
        };
      });

      rowData.value = [...tempArray];
      loading.value = false;
    }

    function toggleNoScopeFilter() {
      CommonAdminHelper.toggleNoScopeFilter(filter, noScopeFilter);
    }

    function customFilter(rows) {
      return CommonAdminHelper.customFilter(rows, filter, noScopeFilter);
    }

    function addRow() {
      emit("setAdminMode", "Add User Group");
      props.adminForm.addRow();
    }

    function editRow(prop) {
      emit("setAdminMode", "Update User Group");
      props.adminForm.editRow(prop);
    }

    function deleteRow(prop) {
      props.adminDelete.deleteRow(prop);
    }

    return {
      //helper
      CommonAdminHelper,

      //variable properties
      columnDefs,
      rowData,
      filter,
      loading,
      pagination,
      noScopeFilter,

      //functions
      getUserGroups,
      toggleNoScopeFilter,
      customFilter,
      addRow,
      editRow,
      deleteRow
    };
  },
};
</script>
